import script from "./Buildings.vue?vue&type=script&setup=true&lang=js"
export * from "./Buildings.vue?vue&type=script&setup=true&lang=js"

import "./Buildings.vue?vue&type=style&index=0&id=6e56319a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e56319a"]])

export default __exports__